import DOMPurify from 'dompurify';

const PROVIDER_DESCRIPTION_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'a',
  'ul',
  'ol',
  'li',
];

const PROVIDER_DESCRIPTION_ALLOWED_ATTR = ['href', 'target', 'rel', 'style'];

const PROVIDER_DESCRIPTION_URI_REGEXP = /^(?:https?|mailto):/i;

const ALLOWED_LINK_TARGETS = new Set(['_blank', '_self', '_parent', '_top']);

const TEXT_ALIGN_STYLE_REGEXP =
  /text-align\s*:\s*(left|center|right)\s*;?/i;

const uponSanitizeProviderDescriptionAttribute = (
  _node: Element,
  data: DOMPurify.UponSanitizeAttributeHookEvent
) => {
  // DOMPurify гоняет target/rel через ALLOWED_URI_REGEXP — без forceKeepAttr они срезаются
  if (data.attrName === 'target' && ALLOWED_LINK_TARGETS.has(data.attrValue)) {
    data.forceKeepAttr = true;

    return;
  }

  if (data.attrName === 'rel') {
    data.forceKeepAttr = true;

    return;
  }

  if (data.attrName !== 'style') {
    return;
  }

  const textAlignMatch = data.attrValue.match(TEXT_ALIGN_STYLE_REGEXP);

  if (textAlignMatch) {
    data.attrValue = `text-align: ${textAlignMatch[1]}`;

    return;
  }

  data.keepAttr = false;
};

export const sanitizeProviderDescription = (html: string): string => {
  DOMPurify.addHook(
    'uponSanitizeAttribute',
    uponSanitizeProviderDescriptionAttribute
  );

  try {
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: PROVIDER_DESCRIPTION_ALLOWED_TAGS,
      ALLOWED_ATTR: PROVIDER_DESCRIPTION_ALLOWED_ATTR,
      ALLOWED_URI_REGEXP: PROVIDER_DESCRIPTION_URI_REGEXP,
    });
  } finally {
    DOMPurify.removeHook('uponSanitizeAttribute');
  }
};
